import React, { useState, useEffect } from 'react';

const AutocompleteSocio = ({ options, value, onChange, placeholder }) => {
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const selectedItem = options.find(o => o.cedula === value);
    if (selectedItem && !isOpen) {
      setSearch(selectedItem.username || '');
    } else if (!value && !isOpen) {
      setSearch('');
    }
  }, [value, options, isOpen]);

  const filteredOptions = options.filter(m => 
    (m.username || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="relative">
      <input
        type="text"
        className="w-full border border-gray-300 rounded px-3 py-2 pr-10 focus:outline-none focus:ring-1 focus:ring-[#10174c]"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setIsOpen(true);
          onChange(''); // Reset selection on type
        }}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setTimeout(() => setIsOpen(false), 200)}
        placeholder={placeholder || "Escriba para buscar..."}
      />
      {search && (
        <button
          type="button"
          onMouseDown={(e) => {
            // Prevent input blur to keep focus and dropdown behavior if desired
            e.preventDefault();
            setSearch('');
            onChange('');
            setIsOpen(true);
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-900 font-bold focus:outline-none p-1"
          title="Borrar"
        >
          &#x2715;
        </button>
      )}
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.map(m => (
            <div
              key={m.cedula || m._id}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              onMouseDown={() => {
                setSearch(m.username);
                onChange(m.cedula);
                setIsOpen(false);
              }}
            >
              {m.username}
            </div>
          ))}
          {filteredOptions.length === 0 && (
            <div className="px-3 py-2 text-sm text-gray-500">No se encontraron resultados</div>
          )}
        </div>
      )}
    </div>
  );
};

export default AutocompleteSocio;
